import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=5b2536e8&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"
import style0 from "./Page.vue?vue&type=style&index=0&id=5b2536e8&prod&lang=scss&scoped=true"
import style1 from "./Page.vue?vue&type=style&index=1&id=5b2536e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2536e8",
  null
  
)

export default component.exports